import React from 'react'
import { useIntl } from 'react-intl'
import { getAssetUrl } from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import { OrderProductLineItem, roundedPrice } from 'msp-integrations'
import { Spinner } from 'msp-components'
import useProduct from '@/hooks/use-product'
import translations from '../../AccountOrders/AccountOrderDetail/OrderProductItemsList/OrderProductItemsList.constants'
import * as S from '../../AccountOrders/AccountOrderDetail/OrderProductItemsList/OrderProductItemsList.styles'

export const StandingOrdersDetailsProductListItem = ({
  productItem,
  currency
}: {
  productItem: OrderProductLineItem
  currency: string
}) => {
  const { formatMessage, formatNumber } = useIntl()
  const fallBackImage = getAssetUrl('static/img/fallback-product-image.png')
  const handleImageNotFound = (el: HTMLImageElement) => {
    if (el.src !== fallBackImage) {
      el.src = fallBackImage
    }
  }

  const fullProduct = {
    ...useProduct(productItem.productId),
    quantity: productItem.quantity
  }

  if (!fullProduct || fullProduct?.showLoading) {
    return <Spinner />
  }

  return (
    <div className={S.ProductLineItemWrapper}>
      <div className={S.ProductLineItemArticleWrapper}>
        <div className={S.ProductLineItemArticleImageWrapper}>
          <div className={S.ProductLineItemArticleImageContainer}>
            {fullProduct.c_image && (
              <img
                className={S.ProductLineItemArticleImage}
                src={fullProduct.c_image}
                onError={(ev) =>
                  handleImageNotFound(ev.target as HTMLImageElement)
                }
                alt={fullProduct.name}
              />
            )}
            {!fullProduct?.c_image && (
              <img
                src={fallBackImage}
                alt={fullProduct.name}
                className={S.ProductLineItemArticleImage}
              />
            )}
          </div>
        </div>
        <div className={S.ProductLineItemArticleDetailsWrapper}>
          <div className={S.ProductLineItemArticleName}>{fullProduct.name}</div>
          <div className={S.ProductLineItemArticleDescription}>
            {fullProduct.c_servings || ''}
          </div>
          <div className={S.ProductLineItemArticleNumber}>
            {formatMessage(translations.articleNumber, {
              articleNo: fullProduct.id
            })}
          </div>
        </div>
      </div>
      <div className={S.ProductLineItemTableQuantity}>
        {fullProduct.quantity}
      </div>
      <div className={S.ProductLineItemTableUnitPrice}>
        {formatNumber(fullProduct.pricePerUnit, {
          style: 'currency',
          currency,
          currencyDisplay: 'code'
        })}
      </div>
      <div className={S.ProductLineItemTableTotal}>
        <div
          className={
            fullProduct?.c_priceDiscounted &&
            fullProduct.c_priceDiscounted !== fullProduct.price
              ? S.ProductLineItemTableTotalBasePrice
              : ''
          }
        >
          {formatNumber(
            roundedPrice(fullProduct.price * fullProduct.quantity),
            {
              style: 'currency',
              currency,
              currencyDisplay: 'code'
            }
          )}
        </div>
        {fullProduct?.c_priceDiscounted &&
          fullProduct.priceAfterItemDiscount !== fullProduct.price && (
            <div className={S.ProductLineItemTableTotalPromoPrice}>
              {formatNumber(
                roundedPrice(
                  fullProduct?.c_priceDiscounted * fullProduct.quantity
                ),
                {
                  style: 'currency',
                  currency,
                  currencyDisplay: 'code'
                }
              )}
            </div>
          )}
      </div>

      <div className={S.ProductLineItemDetailsWrapper}>
        <div className={S.ProductLineItemQuantityStatusWrapper}>
          <div className={S.ProductLineItemQuantityWrapper}>
            {fullProduct.quantity} x{' '}
            {formatNumber(fullProduct.pricePerUnit, {
              style: 'currency',
              currency,
              currencyDisplay: 'code'
            })}
          </div>
        </div>
        <div className={S.ProductLineItemPriceInfoWrapper}>
          <div
            className={
              fullProduct?.c_priceDiscounted &&
              fullProduct.c_priceDiscounted !== fullProduct.price
                ? S.ProductLineItemTableTotalBasePrice
                : ''
            }
          >
            {formatNumber(
              roundedPrice(fullProduct.price * fullProduct.quantity),
              {
                style: 'currency',
                currency,
                currencyDisplay: 'code'
              }
            )}
          </div>
          {fullProduct.c_priceDiscounted &&
            fullProduct.c_priceDiscounted !== fullProduct.price && (
              <div className={S.ProductLineItemTableTotalPromoPrice}>
                {formatNumber(
                  roundedPrice(
                    fullProduct.c_priceDiscounted * fullProduct.quantity
                  ),
                  {
                    style: 'currency',
                    currency,
                    currencyDisplay: 'code'
                  }
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  )
}
